import React from 'react';
import './OutreachFunding.css';

const OutreachFunding = () => {
  const fundingOpportunities = [
    {
      title: "Funding Opportunities",
      description: "This section is under construction. Official information about available funding calls will be posted here soon.",
      deadline: "Coming soon",
      eligibility: "Under update",
      amount: "To be announced"
    },
    {
      title: "Fellowships & Support",
      description: "Details about fellowships, student support, and related opportunities are being prepared.",
      deadline: "Coming soon",
      eligibility: "Under update",
      amount: "To be announced"
    }
  ];

  const outreachPrograms = [
    {
      title: "Outreach Programs",
      description: "Information about CIP outreach activities and engagement initiatives will be added here soon.",
      activities: [
        "Program details coming soon",
        "Activity schedule under construction",
        "Updates will be shared here"
      ]
    },
    {
      title: "Collaborations & Partnerships",
      description: "Partnership and collaboration opportunities are currently being updated.",
      activities: [
        "Partnership details coming soon",
        "Industry engagement updates coming soon",
        "Further information will appear here"
      ]
    }
  ];

  return (
    <div className="outreach-funding-container">
      <h1 className="page-header">Outreach & Funding</h1>

      {/* Funding Section */}
      <section className="funding-section">
        <h2>Funding Opportunities</h2>
        <div className="funding-grid">
          {fundingOpportunities.map((opportunity, index) => (
            <div key={index} className="funding-card">
              <h3>{opportunity.title}</h3>
              <p>{opportunity.description}</p>
              <div className="funding-details">
                <div className="detail-item">
                  <span className="label">Deadline:</span>
                  <span>{opportunity.deadline}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Eligibility:</span>
                  <span>{opportunity.eligibility}</span>
                </div>
                <div className="detail-item">
                  <span className="label">Amount:</span>
                  <span>{opportunity.amount}</span>
                </div>
              </div>
              <button className="apply-button" disabled>Coming Soon</button>
            </div>
          ))}
        </div>
      </section>

      {/* Outreach Section */}
      <section className="outreach-section">
        <h2>Outreach Programs</h2>
        <div className="outreach-grid">
          {outreachPrograms.map((program, index) => (
            <div key={index} className="outreach-card">
              <h3>{program.title}</h3>
              <p>{program.description}</p>
              <div className="activities-list">
                <h4>Coming Soon:</h4>
                <ul>
                  {program.activities.map((activity, aIndex) => (
                    <li key={aIndex}>{activity}</li>
                  ))}
                </ul>
              </div>
              <button className="learn-more-button" disabled>Coming Soon</button>
            </div>
          ))}
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <h2>Get In Touch</h2>
        <p>
          Contact details, guidelines, and related outreach or funding
          information are currently being updated.
        </p>
        <div className="contact-buttons">
          <button className="contact-button primary" disabled>Contact Details Coming Soon</button>
          <button className="contact-button secondary" disabled>Guidelines Coming Soon</button>
        </div>
      </section>
    </div>
  );
};

export default OutreachFunding; 
